module.exports = __webpack_public_path__ + "static/media/intro-mobile-zh-CN.50370d50.png";